<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SnN4SJ/tc-custom/9781399007481.jpg?1712387828922" alt="This image is the cover for the book From Lightnings to MiGs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Lightnings to MiGs
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Royal Air Force pilot chronicles his career flying during the Cold War in this memoir featuring previously unseen photographs.</b><br/><br/> It was supposed to be just a training flight. The two Soviet-manufactured MiG 21s, each with two practice bombs and four air-to-ground rockets, were lined up on the runway in Bangladesh at the height of the Cold War, when air traffic control suddenly reported an incursion by Indian Air Force Jaguars. Though ill-equipped for combat, the two MiGs were scrambled.<br/><br/> One of the MiGs’ pilots was an RAF officer—Squadron Leader Russell Peart. On a seven-month loan to the Bangladeshi Air Force, Peart suddenly found himself at the centre of the simmering hostility between two neighbouring nations. By the time they reached the area that had been threatened by the Indian pilots, the Jaguars had gone. Later, when Squadron Leader Russell Peart spoke of the incident to the British High Commissioner, he was told not to shoot down any Jaguars as the Indians had still not paid for them!<br/><br/> Russell Peart flew many other aircraft in his varied career, including the MiG 19, and while a test pilot at Boscombe Down trialled such designs as the Tornado GR1. But it was whilst he was seconded to the Sultan of Oman’s Air Force, particularly during the so-called “Secret War” in Dhofar, that he saw the most action. In that theatre the author flew some 200 operational sorties, 180 of which involved live fire, during which he was hit many times. He was also hit and wounded by a 75mm shell.<br/><br/> Russ Peart has written in detail of his exciting RAF career, from flying Lightnings in the Far East to winning the top prize in the International Tactical Bombing Competition against a handpicked team of United States Air Force fighter pilots and being awarded the Sultan of Oman’s Distinguished Service Medal. Supplemented by a selection of previously unseen photographs, this uniquely original memoir throws new light on the operational flying undertaken by some RAF pilots during the tense years of the Cold War.<br/><br/><b>Praise for <i>From Lightnings to MiGs</i><br/><br/> “Absorbing and highly entertaining. . . . I have no hesitation in recommending <i>From Lightnings to MiGs</i> as an engrossing and enjoyable read for anyone with an interest in military aviation.” —RAF Historical Society<br/><br/> “There’s some pretty jaw-dropping stuff in here.” —Rowland White, author of <i>Vulcan 607</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Russ Peart
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Air World
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?706311f8